import Vue from 'vue'
import VueTheMask from 'vue-the-mask';
import App from './App.vue'

import './registerServiceWorker'

import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

import VCurrencyField from 'v-currency-field'
import {
  VBtn,
  VCard,
  VCardSubtitle,
  VCardText,
  VCardTitle,
  VCheckbox,
  VChip,
  VDialog,
  VDivider,
  VFileInput,
  VIcon,
  VImg,
  VRadio,
  VRadioGroup,
  VSelect,
  VSnackbar,
  VTextField,
} from 'vuetify/lib'

import { setupBaseURL, setupApiOnResponseError } from './services/api-recebimentoweb';
import { ROUTE_SIGN_IN } from './constants/ROUTES';
import { SetupIsOnline } from './utils/isonline';
setupBaseURL(); // URL Padrão API
SetupIsOnline(); // Eventos da Página Offline/Online

// Registro global manual: componentes do Vuetify usados dentro de pacotes externos
// pré-compilados (ex.: @officeline-libs/checklist, v-currency-field) não são detectados
// pelo vuetify-loader (que só varre os templates .vue deste projeto), então precisam
// ser registrados explicitamente para não virarem "Unknown custom element".
[
  ['v-btn', VBtn],
  ['v-card', VCard],
  ['v-card-subtitle', VCardSubtitle],
  ['v-card-text', VCardText],
  ['v-card-title', VCardTitle],
  ['v-checkbox', VCheckbox],
  ['v-chip', VChip],
  ['v-dialog', VDialog],
  ['v-divider', VDivider],
  ['v-file-input', VFileInput],
  ['v-icon', VIcon],
  ['v-img', VImg],
  ['v-radio', VRadio],
  ['v-radio-group', VRadioGroup],
  ['v-select', VSelect],
  ['v-snackbar', VSnackbar],
  ['v-text-field', VTextField],
].forEach(([tag, component]) => Vue.component(tag, component));

Vue.use(VCurrencyField, {
	locale: 'pt-BR',
  allowNegative: false
})

Promise.all([
  setupBaseURL(),
  setupApiOnResponseError(async (err) => {
    if (err.response?.status === 401 && store.getters['auth/accessToken']) {
      await store.dispatch('auth/unauthenticate');

      if (router.currentRoute.path === ROUTE_SIGN_IN.name) return;

      router.push({
        path: ROUTE_SIGN_IN.name,
        query: { origin: router.currentRoute.fullPath },
      });
    }

    throw err;
  }),

])
  .then(() => {
    store.dispatch('$_setup');
  })
  .then(() => {
    Vue.use(VueTheMask);
    new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app')
  });

